import "./App.css";
import { Navbar } from "./Components/Navbar/Navbar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Shop from "./Pages/Shop";
import ShopCategory from "./Pages/ShopCategory";
import Product from "./Pages/Product";
import Cart from "./Pages/Cart";
import LoginSignup from "./Pages/LoginSignup";
import Footer from "./Components/Footer/Footer";
import toys_banner from './Components/Assets/toys_banner.jpg'
import kanha_dress from './Components/Assets/kanha_dress.jpg'
import gift_items from './Components/Assets/gift_items.jpg'
import AboutUs from "./Components/About/AboutUs";
import SubscriptionStatus from "./Components/Subscription/SubscriptionStatus";
import SubscriptionFailed from "./Components/Subscription/SubscriptionFailed";
import UserProfile from "./Components/UserProfile/UserProfile";
import UserWishlist from "./Components/UserWishlist/UserWishlist";
import ProtectedRoute from "./Components/Route/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SupportTickets from "./Components/SupportTickets/SupportTickets";
import TicketDetails from "./Components/TicketDetails/TicketDetails";
import SessionExpiredModal from "./Components/SessionExpiredModal/SessionExpiredModal";

/* 
  Categories :

  Stationery = 1
  Toys = 2
  Gifts = 3
  Kanha Dress = 4
  Cosmetics = 5
  Mata Dress = 5

 */

function App() {
  return (
    <div>
      <SessionExpiredModal />
      <BrowserRouter>
        <ToastContainer position="top-center"   // base position
          autoClose={2000}
          closeButton={false}     // ❌ remove cross icon
          hideProgressBar={true}
          pauseOnHover={false}
          draggable={false}
          className="toast-center" />

        <Navbar />

        <Routes>
          <Route path="/subscriptionstatus" element={<SubscriptionStatus />} />
          <Route path="/subscriptionfailed" element={<SubscriptionFailed />} />
          <Route path="/" element={<Shop />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/toys" element={<ShopCategory banner={toys_banner} category="2" />} />
          <Route
            path="/kanhadress"
            element={<ShopCategory banner={kanha_dress} category="4" />}
          />
          <Route
            path="/giftitems"
            element={<ShopCategory banner={gift_items} category="3" />}
          />
          <Route
            path="/userprofile"
            element={<ProtectedRoute> <UserProfile /> </ProtectedRoute>}
          />
          <Route
            path="/userwishlist"
            element={<ProtectedRoute> <UserWishlist /> </ProtectedRoute>}
          />
          <Route
            path="/support"
            element={<ProtectedRoute> <SupportTickets /> </ProtectedRoute>}
          />
          <Route path="/support/:ticketid" element={<ProtectedRoute> <TicketDetails /> </ProtectedRoute>} />
          <Route path="/product" element={<Product />}>
            <Route path=":productId" element={<Product />} />
          </Route>
          <Route path="/cart" element={<Cart />} />
          <Route path="/login" element={<LoginSignup />} />

        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
